import React from 'react';
import { useParams } from 'react-router-dom';

import { EventRegistration } from '../../../Data/Classes';
import { USER, REGISTERED, NULL } from '../../../Data/Constants';
import EventRegistrationEditForm from './EventRegistrationEditForm';

function EventRegistrationCreatePage(props) {
    const { eventId } = useParams();

    const eventReg = new EventRegistration(0, USER, REGISTERED, 0, '', '', '', '', '', '', NULL, '', eventId);
    return (
        <>
            <h1>Rendezvény-jelentkezés létrehozása</h1>
            <EventRegistrationEditForm eventReg={eventReg} />
        </>
    );
}

export default EventRegistrationCreatePage;
